export default __webpack_public_path__ + "static/media/DisneySnowWhite.20151075.jpg";